import { getValueFromLOVDescription, LOV_CODES } from '../../../../utils'
import { STORE_MERCHANT } from '../../../../utils/constants'
import { authorizedSignatoryForm } from './authorizedSingnatoryForm'
import { bankDetailsForm } from './bankDetailsForm'
import { businessDetailsForm } from './businessDetailsForm'
import { documentUploadForm } from './documentUploadForm'
import { feePackageDetailForm } from './feePackageDetailForm'
import { interactionHistoryForm } from './interactionHistoryForm'
import { kycApprovalForm } from './kycApprovalForm'
import { otherBusinessDetailsForm } from './otherBusinessDetailsForm'
import { personalDetailForm } from './personalDetailsForm'
import { riskSettingForm } from './riskSettingForm'
import { selectParentEntityForm } from './selectParentEntityForm'

export const getFormData = (dropDownData: any = [], isEditable: boolean, userType: any, initialValues: any) => {
  const isCommonFormEditable =
    isEditable && !['riskCheckerMyQueue', 'riskMakerMyQueue', 'RISK_MAKER_SEARCH_ENTITY'].includes(userType)
  const isStoreMerchant = initialValues?.merchantType === STORE_MERCHANT
  const isProfileUpdate = ['UPDATE_PROFILE', 'RISK_UPDATE_PROFILE'].includes(initialValues?.requestType)
  const formData = [
    personalDetailForm(dropDownData?.lovData, isCommonFormEditable, isStoreMerchant, isProfileUpdate),
    authorizedSignatoryForm(dropDownData, isCommonFormEditable, isStoreMerchant),
    businessDetailsForm(dropDownData, isCommonFormEditable, isStoreMerchant),
    otherBusinessDetailsForm(dropDownData?.lovData, isCommonFormEditable, isStoreMerchant),
    bankDetailsForm(dropDownData, isCommonFormEditable, isStoreMerchant),
    documentUploadForm(dropDownData, isCommonFormEditable, isStoreMerchant),
    feePackageDetailForm(dropDownData, isCommonFormEditable, isStoreMerchant),
  ]
  if (
    [
      'checker1MyQueue',
      'checker2MyQueue',
      'riskCheckerMyQueue',
      'riskMakerMyQueue',
      'checker1Queue',
      'checker2Queue',
      'riskCheckerQueue',
      'riskMakerQueue',
      'INCIDENT_DETAILS',
    ].includes(userType)
  ) {
    formData.unshift(
      selectParentEntityForm(
        dropDownData?.lovData,
        isCommonFormEditable && initialValues.requestType === 'NEW_PROFILE',
      ) as any,
    )
  }
  if (['MAKER_SEARCH_ENTITY', 'RISK_MAKER_SEARCH_ENTITY', 'DEFAULT_SEARCH_ENTITY'].includes(userType)) {
    formData.unshift(selectParentEntityForm(dropDownData?.lovData, false) as any)
    if (!isEditable || ['RISK_MAKER_SEARCH_ENTITY'].includes(userType)) {
      formData.push(
        riskSettingForm(dropDownData, isEditable && userType === 'RISK_MAKER_SEARCH_ENTITY', initialValues) as any,
      )
    }
  } else if (userType) {
    formData.push(
      kycApprovalForm(
        false,
        ['riskCheckerMyQueue', 'riskMakerMyQueue', 'riskCheckerQueue', 'riskMakerQueue'].includes(userType),
      ) as any,
    )
  }
  if (
    ['riskCheckerMyQueue', 'riskMakerMyQueue', 'riskCheckerQueue', 'riskMakerQueue', 'INCIDENT_DETAILS'].includes(
      userType,
    )
  ) {
    formData.push(riskSettingForm(dropDownData, isEditable, initialValues) as any)
  }

  if (
    ['checker2MyQueue', 'checker2Queue'].includes(userType) &&
    (getValueFromLOVDescription(dropDownData?.lovData, initialValues?.businessChannel, 'BusinessChannel') ===
      LOV_CODES.ONLINE ||
      initialValues?.requestType === 'UPDATE_PROFILE')
  ) {
    formData.push(riskSettingForm(dropDownData, false, initialValues) as any)
  }

  if (
    [
      'riskCheckerMyQueue',
      'riskMakerMyQueue',
      'riskCheckerQueue',
      'riskMakerQueue',
      'RISK_MAKER_SEARCH_ENTITY',
    ].includes(userType) ||
    (!isEditable && userType === 'MAKER_SEARCH_ENTITY')
  ) {
    formData.push(interactionHistoryForm(initialValues) as any)
  }

  return formData
}
